<!--
  CollectorLineChips — which variant and whose line, as two chips that look the
  same on every card shape (collector-clarity, handoff spec Section 6.4): the
  variant filled lilac, the member code bordered. They replace the grey
  bracketed variant after the name and the grey code inside the sentence.

  `row` is a grouped member row: «أي لون» stands where she named no variant,
  and the code chip always draws. `size="sm"` is a row or a compact card.
  Spans, so it can sit inside a card's open target (a <button>).
-->
<template>
  <span v-if="variant || row || code" class="c-tags" :class="{ 'c-tags--sm': size === 'sm' }">
    <span v-if="variant" class="c-variant">{{ variant }}</span>
    <span v-else-if="row" class="c-variant c-variant--any">{{ t('collector.card.anyColour') }}</span>
    <span v-if="row || code" class="c-code c-num">
      {{ t('collector.line.code', { code: code ?? '—' }) }}
    </span>
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { colourWord } from '@/collector/lineView.js';

const props = defineProps({
  line: { type: Object, required: true },
  /** `md` 15 px variant; `sm` 13 px (a member row, a compact card). */
  size: { type: String, default: 'md' },
  /** A grouped member row: «أي لون» when there is no variant, and the code always. */
  row: { type: Boolean, default: false },
});

const { t } = useI18n();

const variant = computed(() => colourWord(props.line));
/** Her code, or null when it is missing or blank (a row then reads «كود —»). */
const code = computed(() => {
  const text = String(props.line.memberCode ?? '').trim();
  return text === '' ? null : text;
});
</script>

<style scoped>
.c-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.c-variant {
  padding: 2px 10px;
  border-radius: 8px;
  background: var(--c-lilac);
  color: var(--c-indigo);
  font-size: 15px;
  font-weight: 700;
}

.c-variant--any {
  background: var(--c-ground);
  color: var(--c-ink-soft);
}

.c-code {
  padding: 1px 8px;
  border: 1px solid var(--c-border);
  border-radius: 8px;
  color: var(--c-ink);
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
}

.c-tags--sm { gap: 5px; }

.c-tags--sm .c-variant {
  padding: 1px 8px;
  font-size: 13px;
}
</style>
